import React from 'react'
import ReactDOM from 'react-dom'

import App from './components/globals/App'

import './index.css'

// Default Service Worker From create-react-app
// import registerServiceWorker from './registerServiceWorker'
// persistor.purge()

if (typeof navigator.serviceWorker !== 'undefined') {
  navigator.serviceWorker.register('/pwabuilder-sw.js')
}

ReactDOM.render(
  <App />
  , document.getElementById('root'))

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js